var React = require('react');

function C2cPlayLargeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"play","d":"M37.881 30.334L59.55 42.795c1.158.665 1.158 2.16 0 2.825L37.88 58.08c-1.158.665-2.481-.166-2.481-1.495V31.83c0-1.33 1.489-1.994 2.481-1.496z","fill":"#EBEFFF"}));
}

C2cPlayLargeInline.defaultProps = {"fill":"none","viewBox":"0 0 88 87"};

module.exports = C2cPlayLargeInline;

C2cPlayLargeInline.default = C2cPlayLargeInline;
